import { Controller, useForm } from "react-hook-form";
import { Button, Form } from "reactstrap";
import { FileInputField, InputField, TextAreaField } from "../../../CommonElements";
import { useDokumen } from "../../../Context/DokumenContext";

const DokumenForm = ({resetState, toggle}) => {
  const dokumenAPI = useDokumen();
  const { control, handleSubmit } = useForm();

  const createItem = (data) => {
    dokumenAPI.createDokumen(data).then(() => {
      resetState();
      toggle();
    });
  };


  return (
    <Form onSubmit={handleSubmit(createItem)}>
      <Controller
        name="judul"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Judul"}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="deskripsi"
        control={control}
        render={({ field, fieldState }) => (
          <TextAreaField
            label={"Deskripsi"}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="berkas"
        control={control}
        rules={{
          required: "Harap upload berkas tanda terima",
        }}
        render={({ field, fieldState }) => (
          <FileInputField
            label={"Berkas"}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default DokumenForm;
